export const filename: string = 'Price_Scenarios_Finder-download-';
export const fileExtension: string = '.xlsx';
